import { Maps } from 'js/components/Maps/index.js';
import { GoogleMapsEnterprise } from 'js/components/Maps/GoogleMapsEnterprise--override.js';

export class LocationMap extends GoogleMapsEnterprise {
  static initClass() {
    this.instances = [];
    this.providerLoaded = false;
    this.className = "Yext.Maps.LocationMap";
    this.version = "v3.0.1";
    Maps.FactoryForProvider.Google = (data) => new this(data);
  }

  constructor(args) {
    super(args);
    this.pinWidth = 32;
    this.pinHeight = 38;
  }

  svgPin(label, backgroundColor, textColor) {
    return `
      <svg xmlns="http://www.w3.org/2000/svg" width="32" height="38" viewBox="0 0 32 38">
        <g fill="none" fill-rule="evenodd">
          <path fill="#333" d="M32 15.385c.005 4.986-2.509 9.664-6.74 12.545l-.313.216c-6.318 4.38-7.367 7.202-7.877 8.689C16.804 37.62 16.688 38 16 38c-.687 0-.803-.38-1.068-1.165-.51-1.48-1.56-4.309-7.877-8.682l-.313-.217C.563 23.72-1.693 15.914 1.336 9.236 4.366 2.557 11.85-1.162 19.266.326 26.684 1.813 31.999 8.099 32 15.385z"/>
          <ellipse cx="16" cy="15.5" fill="#FFF" rx="4.645" ry="4.5"/>
        </g>
      </svg>
    `;
  }

  prepareMap() {
    const map = super.prepareMap();
    map.setOptions({
      zoomControlOptions: {
        position: google.maps.ControlPosition.RIGHT_BOTTOM
      }
    });
    return map;
  }
}
